import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 箱货信息
export function airUldList(params) {
  return request({
    url: URL.seaExport.airUld,
    method: 'get',
    params
  })
}
